<template>
    <div class="container-fluid">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div v-if="(id > 0)" class="col-sm-6">
                        <h1>{{ $t('general.Tipo Daño') }}</h1>
                    </div>
                    <div v-else class="col-sm-6">
                        <h1>{{ $t('general.Crear Tipos de daño') }}</h1>
                    </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <!-- Ocultar esta columna en la creación -->
                <div v-if="(id > 0)" class="col-md-2">
                    <!-- Datos correos -->
                    <div class="card bg-gradient-primary">
                        <div class="card-body box-profile">
                            <h3 class="profile-username text-center">{{ tipo_danyo.danyo }}</h3>
                        </div>
                    </div>
                    <!--<div class="callout callout-info">
                  <h5>Última modificación</h5>
                    <p>15/12/2021 15:35h por soporte2</p>
                    </div>-->
                </div>
                <div class="col-md-6">
                    <div v-if="(id > 0)" class="card card-default card-tabs">
                        <div class="card-header p-1 pt-1">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link active" href="#datos_estado_pendiente" data-toggle="tab">{{
                                    $t('general.datos') }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="tab-content">
                        <div class="active tab-pane" id="datos_tipo_danyo">
                            <div v-if="id>0">
                                <tipo-danyo-datos :id="id" :key="id" />
                            </div>
                            <div v-else>
                                <tipo-danyo-datos :id="id" :key="id" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import TiposDanyoDatos from './TiposDanyoDatos.vue'
export default {
    components: {
        'tipo-danyo-datos': TiposDanyoDatos,
    },
    props: ['id'],
    data() {
        return {
            tipo_danyo: [],
        }
    },
    methods: {
        async obtenerTipoDanyo(id) {
            /* get  modulos/pwgsapi/index.php/bancos/:id */
            const api = new PwgsApi;
            const datos = await api.get('tipos-dano/' + id);
            this.tipo_danyo = datos.datos;
            /**/
            let ventana = '';
            let ventanaid = this.$props.id.toString();
            let ventanas = this.$store.getters.ventanas;
            for (let i = 0; i < ventanas.length; i++) {
                ventana = this.$store.getters.ventanas[i].path;
                if (ventana == '/tiposdanyo/' + ventanaid) {
                    if(this.id>0){
                        this.$store.getters.ventanas[i].name = this.tipo_danyo.danyo;
                        this.$store.getters.ventanas[i].alt = "Tipo Daño: " + this.tipo_danyo.danyo;
                    }else{
                        this.$store.getters.ventanas[i].name = "Crear tipo de daño";
                        this.$store.getters.ventanas[i].alt = "Crear tipo de daño";
                    }
                }
            }
            /**/
        },

        cambios() {
            this.obtenerTipoDanyo(this.id);
        },
        recargar() {
            this.obtenerTipoDanyo(this.id);
        },
    },
    mounted() {
        this.obtenerTipoDanyo(this.id);
    },
    watch: {
        id() {
            this.obtenerTipoDanyo(this.id);
        },
    }
}
</script>
